import { render } from "./Add.vue?vue&type=template&id=fd0c8ea2"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Tags/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd0c8ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd0c8ea2', __exports__)) {
    api.reload('fd0c8ea2', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=fd0c8ea2", () => {
    api.rerender('fd0c8ea2', render)
  })

}


export default __exports__